export default __webpack_public_path__ + "static/media/mobileWef6Full.e5941c96.png";